module.exports = __webpack_public_path__ + "img/8d888207a721614220f7c1575593edd7.a1c8e485.png";